import { HTMLAttributes, PropsWithChildren } from "react";

type CubeMaskProps = HTMLAttributes<HTMLDivElement>;

export function CubeMask({
  children,
  ...props
}: PropsWithChildren<CubeMaskProps>) {
  return (
    <div
      style={{
        clipPath:
          "polygon(10.795499801635742% 0%, 1.210077166557312% 50.61126708984375%, 28.27924156188965% 92.01506042480469%, 77.72628784179688% 82.25016021728516%, 96.58820343017578% 34.91880416870117%, 61.21630096435547% 10.267709732055664%, 10.795499801635742% 0%)",
      }}
      {...props}
    >
      {children}
    </div>
  );
}
